module.exports = __webpack_public_path__ + "img/pick5.900a2766.png";